import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { CountdownValidationProps, CountdownValidationState } from "./CountdownValidation.types";

const initialStates: CountdownValidationState = {
  activeCountdown: [],
};

export const useCountdownValidation = create(
  devtools(
    persist<CountdownValidationProps>(
      (set, get): CountdownValidationProps => ({
        ...initialStates,

        getActiveCountdown: (type, timer) => {
          const { activeCountdown, removeCountdown } = get();
          let countdown = 0;
          const data = activeCountdown.find(active => active.type === type);
          if (data) {
            const runningTime = Math.round((Date.now() - data.timeStamp) / 1000); // seconds
            countdown = timer - runningTime; // seconds
          }
          if (countdown <= 0) {
            removeCountdown(type);
            countdown = 0;
          }
          return countdown;
        },

        setActiveCountdown: type => {
          const { activeCountdown } = get();
          const newCountdown = { timeStamp: Date.now(), type };
          const data = activeCountdown.find(active => active.type === type);
          if (data) {
            set({ activeCountdown: [...activeCountdown.filter(active => active.type !== type), newCountdown] });
            return;
          }
          set({ activeCountdown: [...activeCountdown, newCountdown] });
        },

        removeCountdown: type => {
          const { activeCountdown } = get();
          const data = activeCountdown.find(active => active.type === type);
          if (data) {
            set({ activeCountdown: [...activeCountdown.filter(active => active.type !== type)] });
          }
        },
      }),
      {
        name: "countdown-validation-store",
      }
    )
  )
);

const initializeStore = (state: CountdownValidationProps) => {};

initializeStore(useCountdownValidation.getState());
